import { render, staticRenderFns } from "./ReinvestmentHints.vue?vue&type=template&id=04d5dc7e&scoped=true"
import script from "./ReinvestmentHints.vue?vue&type=script&lang=js"
export * from "./ReinvestmentHints.vue?vue&type=script&lang=js"
import style0 from "./ReinvestmentHints.vue?vue&type=style&index=0&id=04d5dc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5dc7e",
  null
  
)

export default component.exports